/**
 * Utilidades para formatear fechas de manera segura.
 *
 * MySQL devuelve fechas cómo "YYYY-MM-DD" (DATE) o "YYYY-MM-DDTHH:mm:ss.sssZ" (DATETIME).
 * Si hacemos `new Date("2026-07-05")`, JS lo interpreta cómo UTC midnight.
 * En Argentina (UTC-3) eso se desfasa 3 horas y puede cambiar de día.
 *
 * Está función parsea manualmente para construir un Date LOCAL (no UTC).
 */
export function formatDate(dateStr, options = {}) {
  if (!dateStr) return "";
  // Tomamos solo la parte de fecha (antes de la T)
  const dateOnly = String(dateStr).split("T")[0];
  const [y, m, d] = dateOnly.split("-").map((n) => parseInt(n, 10));
  if (!y || !m || !d) return "";

  const defaultOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  return new Date(y, m - 1, d).toLocaleDateString("es-AR", {
    ...defaultOptions,
    ...options,
  });
}

/**
 * Versión corta: "5 jul 2026"
 */
export function formatDateShort(dateStr) {
  return formatDate(dateStr, { year: "numeric", month: "short", day: "numeric" });
}

/**
 * Para inputs <input type="date">: ya devuelve "YYYY-MM-DD".
 * Si necesitamos mostrar este valor en otro formato, usamos formatDate.
 */
export function dateInputToDisplay(dateStr) {
  return formatDate(dateStr);
}

/**
 * Normaliza un valor de fecha (puede venir cómo Date, string ISO, "YYYY-MM-DD", etc.)
 * a "YYYY-MM-DD" listo para <input type="date">.
 */
export function toDateInputValue(value) {
  if (!value) return "";
  const dateOnly = String(value).split("T")[0];
  return dateOnly;
}